module.exports = __webpack_public_path__ + "img/yxdst10.09d02a4b.png";